import { Router } from '@angular/router';
import { IpAddress } from '../../Model/IpAddresses';
import { ServiceAdminService } from '../../Providers/service-admin.service';
import { CompteServer } from '../../Model/CompteServer';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { IMyOptions } from 'mydatepicker';
import { Headers, RequestOptions } from '@angular/http';

/**
 * created by AHMED HAYEL
 * 
 */
@Component({
  selector: 'app-add-compte-server',
  templateUrl: './add-compte-server.component.html',
  styleUrls: ['./add-compte-server.component.scss']
})
export class AddCompteServerComponent implements OnInit {
  compteServer: CompteServer = new CompteServer();
  numberBoitier: number = 0;
  ipAddresses: IpAddress[];
  private myDatePickerOptions: IMyOptions = {
    dateFormat: 'dd-mm-yyyy',
  };

  private date: any;
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef, private service: ServiceAdminService, private router: Router) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    var currentTime = new Date();
    this.date = { "date": { "year": currentTime.getFullYear() +1, "month": currentTime.getMonth() + 1, "day": currentTime.getDate() }};

    if (this.service.isAuthenticated == false) {
      this.router.navigate(['/error']);
    } else {
      this.ipAddresses = this.service.ips;
    }
  }

  //=====================================
  //           add Server Account
  //=====================================

  addCompteServer() {
    this.compteServer.date_Expiration = new Date(this.date.date.month+'/'+this.date.date.day+'/'+this.date.date.year).getTime();
    this.service.createServerCompte(this.compteServer).subscribe(_compteServer => {
      this.compteServer = new CompteServer();
      var currentTime = new Date();
      this.date = { "date": { "year": currentTime.getFullYear() +1, "month": currentTime.getMonth() + 1, "day": currentTime.getDate() }};

      if (this.numberBoitier != 0) {
        this.service.addBoitiers(_compteServer.idCompteClientServer, this.numberBoitier).subscribe(boitier => {
          this.toastr.success('Server Account added with database name rimtrack_user_' + _compteServer.idCompteClientServer + ' and ' + this.numberBoitier + ' device(s)', 'Success!');
        }, error => { this.toastr.error('There is a mistake', 'Error!') });
      }else{
        this.toastr.success('Server Account added with database name rimtrack_user_' + _compteServer.idCompteClientServer + ' and 0 device(s)', 'Success!');
      }
    }, error => { this.toastr.error('can not add account', 'Error!');});
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-component/add-compte-server/add-compte-server.component.ts